(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cocomii-performance-global"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function applyWalletLayout(wrapper) {
      var selector = 'shop-pay-wallet-button, shopify-apple-pay-button, shopify-paypal-button, shopify-google-pay-button';
      var hosts = Array.prototype.filter.call(wrapper.querySelectorAll(selector), function (host) {
        return host.offsetParent !== null;
      });
      if (!hosts.length) return;

      wrapper.style.setProperty('display', 'block', 'important');
      wrapper.style.setProperty('padding', '0', 'important');
      wrapper.style.setProperty('margin', '0', 'important');
      wrapper.style.setProperty('gap', '0', 'important');

      hosts.forEach(function (host) {
        var shopPay = host.tagName.toLowerCase() === 'shop-pay-wallet-button';
        host.style.setProperty('display', 'block', 'important');
        host.style.setProperty('margin', '0', 'important');
        host.style.setProperty('padding', '0', 'important');
        host.style.setProperty('overflow', shopPay ? 'visible' : 'hidden', 'important');

        if (shopPay) {
          host.style.setProperty('min-height', '48px', 'important');
          host.style.removeProperty('line-height');
          host.style.removeProperty('font-size');
        } else {
          host.style.setProperty('line-height', '0', 'important');
          host.style.setProperty('font-size', '0', 'important');
        }
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var previousBottom = null;
          hosts.forEach(function (host) {
            host.style.setProperty('margin-top', '0', 'important');
            var rect = host.getBoundingClientRect();
            if (previousBottom !== null) {
              var delta = 3 - Math.round(rect.top - previousBottom);
              if (delta) host.style.setProperty('margin-top', delta + 'px', 'important');
            }
            previousBottom = host.getBoundingClientRect().bottom;
          });

          var shopPay = hosts.find(function (host) {
            return host.tagName.toLowerCase() === 'shop-pay-wallet-button';
          });
          if (shopPay) {
            var height = Math.max(Math.round(shopPay.getBoundingClientRect().height) || 0, 48);
            shopPay.style.setProperty('height', height + 'px', 'important');
            shopPay.style.setProperty('min-height', height + 'px', 'important');
          }
        });
      });
    }

    function watchWalletWrapper(wrapper) {
      if (wrapper.dataset.cocomiiWalletWatch === 'true') return;
      wrapper.dataset.cocomiiWalletWatch = 'true';
      var queued = false;
      var schedule = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          applyWalletLayout(wrapper);
        });
      };
      new MutationObserver(schedule).observe(wrapper, { childList: true, subtree: true });
      schedule();
    }

    function initWallets() {
      document.querySelectorAll('.additional-checkout-buttons--vertical, .additional-checkout-buttons').forEach(watchWalletWrapper);
    }

    function initHomeImpactBanner() {
      if (document.body.dataset.pageType !== 'index') return;
      var banner = document.querySelector('section[id$="__169188792383297596"]');
      if (!banner) return;
      var productUrl = '/products/abalone-shell-magsafe-rectangle-case?variant=51249479811383';
      banner.style.cursor = 'pointer';
      banner.addEventListener('click', function (event) {
        var logoLink = banner.querySelector('.gs-full-width-banner-logo-link');
        if (logoLink && logoLink.contains(event.target)) return;
        window.location.href = productUrl;
      });
    }

    initWallets();
    initHomeImpactBanner();
    document.addEventListener('cart:updated', initWallets);
    document.addEventListener('ajaxProduct:added', initWallets);
    document.addEventListener('shopify:section:load', initWallets);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cocomii-product-enhancements"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var modelByCollection = {
      'rectangle-iphone-17-pro-max-case': 'iPhone 17 Pro Max',
      'rectangle-iphone-17-pro-case': 'iPhone 17 Pro',
      'rectangle-iphone-16-pro-max-case': 'iPhone 16 Pro Max',
      'rectangle-iphone-16-pro-case': 'iPhone 16 Pro',
      'rectangle-iphone-16-plus-case': 'iPhone 16 Plus',
      'rectangle-iphone-16-case': 'iPhone 16',
      'rectangle-iphone-15-pro-max-case': 'iPhone 15 Pro Max',
      'rectangle-iphone-15-pro-case': 'iPhone 15 Pro',
      'rectangle-iphone-15-plus-case': 'iPhone 15 Plus',
      'rectangle-iphone-15-case': 'iPhone 15',
      'rectangle-iphone-14-pro-max-case': 'iPhone 14 Pro Max',
      'rectangle-iphone-14-pro-case': 'iPhone 14 Pro',
      'rectangle-iphone-14-plus-case': 'iPhone 14 Plus',
      'rectangle-iphone-14-case': 'iPhone 14',
      'rectangle-iphone-13-pro-max-case': 'iPhone 13 Pro Max',
      'rectangle-iphone-13-pro-case': 'iPhone 13 Pro',
      'rectangle-iphone-13-mini-case': 'iPhone 13 mini',
      'rectangle-iphone-13-case': 'iPhone 13',
      'rectangle-iphone-12-pro-max-case': 'iPhone 12 Pro Max',
      'rectangle-iphone-12-12-pro-case': 'iPhone 12/12 Pro',
      'rectangle-iphone-12-mini-case': 'iPhone 12 mini',
      'rectangle-iphone-11-pro-max-case': 'iPhone 11 Pro Max',
      'rectangle-iphone-11-pro-case': 'iPhone 11 Pro',
      'rectangle-iphone-11-case': 'iPhone 11',
      'rectangle-iphone-se-2022-2020-case': 'iPhone SE 2022/2020/iPhone 8/7',
      'rectangle-case-for-older-iphone-models': 'iPhone XR'
    };

    function selectCollectionModel() {
      var match = window.location.pathname.match(/\/collections\/([^/]+)\/products\//);
      if (!match || !modelByCollection[match[1]]) return true;
      var model = modelByCollection[match[1]].toLowerCase();
      var optionBlocks = document.querySelectorAll('.variant-input-wrap');

      for (var i = 0; i < optionBlocks.length; i++) {
        var block = optionBlocks[i];
        var label = block.previousElementSibling;
        if (!label || label.textContent.trim().toLowerCase().indexOf('model') === -1) continue;
        var controls = block.querySelectorAll('button, input[type="radio"], select');

        for (var j = 0; j < controls.length; j++) {
          var control = controls[j];
          if (control.tagName.toLowerCase() === 'select') {
            for (var k = 0; k < control.options.length; k++) {
              if (control.options[k].text.trim().toLowerCase() === model) {
                control.value = control.options[k].value;
                control.dispatchEvent(new Event('change', { bubbles: true }));
                return true;
              }
            }
          } else {
            var text = (control.textContent || control.value || '').trim().toLowerCase();
            if (text === model) {
              if (control.tagName.toLowerCase() === 'input') {
                control.checked = true;
                control.dispatchEvent(new Event('change', { bubbles: true }));
              } else {
                control.click();
              }
              return true;
            }
          }
        }
      }
      return false;
    }

    var modelAttempts = 0;
    function tryCollectionModel() {
      if (selectCollectionModel()) return;
      modelAttempts += 1;
      if (modelAttempts < 10) setTimeout(tryCollectionModel, 200);
    }

    var deliveryContainers = new WeakSet();
    var pendingDeliveryContainers = new WeakSet();

    function updateDelivery(root) {
      var badge = root.getElementById('ddp-date-fastest-delivery');
      if (badge && badge.textContent.trim() !== 'Expedited Delivery') {
        badge.textContent = 'Expedited Delivery ';
      }

      var unavailable = Array.prototype.find.call(root.querySelectorAll('*'), function (element) {
        return element.textContent && element.textContent.trim() === 'Delivery estimates unavailable for this item and/or location.';
      });
      if (!unavailable) return;

      unavailable.innerHTML = '<span style="font-weight:bold;">Sold Out </span>';
      var addToCart = document.querySelector('.payment-buttons .add-to-cart');
      if (addToCart) {
        addToCart.classList.add('disabled');
        addToCart.setAttribute('disabled', 'disabled');
        var label = addToCart.querySelector('span');
        if (label) label.textContent = 'Unavailable';
      }
    }

    function attachDelivery(container) {
      if (deliveryContainers.has(container) || pendingDeliveryContainers.has(container)) return;
      pendingDeliveryContainers.add(container);
      var attempts = 0;

      function connect() {
        if (!container.isConnected) return;
        var root = container.shadowRoot;
        if (!root) {
          attempts += 1;
          if (attempts < 40) setTimeout(connect, 100);
          return;
        }

        deliveryContainers.add(container);
        updateDelivery(root);
        var queued = false;
        new MutationObserver(function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            updateDelivery(root);
          });
        }).observe(root, { childList: true, subtree: true, characterData: true });
      }

      connect();
    }

    function productTitle() {
      var element = document.querySelector('.product-single__title, .product__title, h1.product-single__title, h1.product__title');
      return element ? element.textContent.trim().toUpperCase() : '';
    }

    function setSelectByText(select, text) {
      if (!select || !text) return;
      var match = Array.prototype.find.call(select.options, function (option) {
        return option.text.trim().toUpperCase() === text.toUpperCase();
      });
      if (!match || select.value === match.value) return;
      select.value = match.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function applyUpsellSelections() {
      var pairings = {
        'REAL MOTHER OF PEARL': ['Matte White', 'Mother Of Pearl'],
        'PEARL': ['Matte White', 'Mother Of Pearl'],
        'CLEAR': ['Matte White', 'Mother Of Pearl'],
        'ABALONE SHELL': ['', 'Abalone Shell'],
        'TORTOISESHELL': ['', 'Tortoiseshell'],
        'EXOTIC': ['', 'Tortoiseshell'],
        'CROCODILE LEATHER': ['', 'Tortoiseshell'],
        'CHECKERED': ['', 'Abalone Shell'],
        'BEACHFRONT': ['Matte Lilac', ''],
        'MARBLE': ['', 'Tortoiseshell']
      };
      var pairing = pairings[productTitle()];
      if (!pairing) return;
      setSelectByText(document.querySelector('select[aria-label*="MAGSAFE RING"]'), pairing[0]);
      setSelectByText(document.querySelector('select[aria-label*="PHONE CHARM WRISTLET"]'), pairing[1]);
    }

    var watchedUpsells = new WeakSet();
    function connectUpsell() {
      var upsell = document.querySelector('[data-essential-upsell-element="container"]');
      if (!upsell || watchedUpsells.has(upsell)) return;
      watchedUpsells.add(upsell);
      applyUpsellSelections();
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          applyUpsellSelections();
        });
      }).observe(upsell, { childList: true, subtree: true });
    }

    function processProductNode(node) {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches && node.matches('delivery-promise-container')) attachDelivery(node);
      if (node.querySelectorAll) node.querySelectorAll('delivery-promise-container').forEach(attachDelivery);
      if (node.matches && node.matches('[data-essential-upsell-element="container"]')) connectUpsell();
      if (node.querySelector && node.querySelector('[data-essential-upsell-element="container"]')) connectUpsell();
    }

    document.querySelectorAll('delivery-promise-container').forEach(attachDelivery);
    connectUpsell();
    tryCollectionModel();

    var main = document.getElementById('MainContent');
    if (main) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(processProductNode);
        });
      }).observe(main, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cocomii-review-enhancements"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function addVerifiedIcon(reviewerInfo) {
      if (reviewerInfo.dataset.cocomiiVerified === 'true') return;
      var name = reviewerInfo.querySelector('.jdgm-reviewer-name');
      if (!name) return;
      reviewerInfo.dataset.cocomiiVerified = 'true';
      var icon = document.createElement('span');
      icon.className = 'jdgm-reviewer-verified-icon';
      icon.innerHTML = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" aria-hidden="true"><path d="M8.9375 10.875L7.6875 9.64583C7.53472 9.49306 7.36111 9.41667 7.16667 9.41667C6.97222 9.41667 6.79861 9.49306 6.64583 9.64583C6.49306 9.79861 6.41667 9.97569 6.41667 10.1771C6.41667 10.3785 6.49306 10.5556 6.64583 10.7083L8.41667 12.4792C8.56944 12.6319 8.74306 12.7083 8.9375 12.7083C9.13194 12.7083 9.30556 12.6319 9.45833 12.4792L13.3542 8.58333C13.5069 8.43056 13.5833 8.25347 13.5833 8.05208C13.5833 7.85069 13.5069 7.67361 13.3542 7.52083C13.2014 7.36806 13.0278 7.29167 12.8333 7.29167C12.6389 7.29167 12.4653 7.36806 12.3125 7.52083L8.9375 10.875ZM10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18Z"></path></svg>';
      name.insertAdjacentElement('afterend', icon);
    }

    function updateReviewNode(root) {
      if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
      if (root.matches && root.matches('.jdgm-reviews-count') && root.textContent.trim() !== '100,000+') {
        root.textContent = '100,000+';
      }
      if (root.querySelectorAll) {
        root.querySelectorAll('.jdgm-reviews-count').forEach(function (count) {
          if (count.textContent.trim() !== '100,000+') count.textContent = '100,000+';
        });
        root.querySelectorAll('.jdgm-reviewer-info').forEach(addVerifiedIcon);
      }
      if (root.matches && root.matches('.jdgm-reviewer-info')) addVerifiedIcon(root);
    }

    var main = document.getElementById('MainContent');
    updateReviewNode(document);
    if (main) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(updateReviewNode);
        });
      }).observe(main, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function () {
    function hydrate(video) {
      if (video.dataset.cocomiiHydrated === 'true') return;
      video.dataset.cocomiiHydrated = 'true';
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      if (reducedMotion || saveData) {
        video.controls = true;
        return;
      }

      var play = video.play();
      if (play !== undefined) {
        play.catch(function () {
          video.controls = true;
        });
      }
    }

    function init(root) {
      var videos = root.querySelectorAll('[data-cocomii-lazy-video]:not([data-cocomii-observed])');
      videos.forEach(function (video) {
        video.dataset.cocomiiObserved = 'true';
        if (!('IntersectionObserver' in window)) {
          hydrate(video);
          return;
        }
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            hydrate(video);
          });
        }, { rootMargin: '300px 0px' });
        observer.observe(video);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
